import { Component, Input, OnInit, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { RacesService, RaceDaysItem} from '../service/races.service';
import { CommonModule } from '@angular/common';
import { FieldsetModule } from 'primeng/fieldset';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-leagueRaceTableV2',
    standalone: true,
    templateUrl: './leagueRaceTableV2.component.html',
    imports: [
        CommonModule,
        TableModule,
        TabsModule,
        FieldsetModule,
        RouterLink
    ],
    providers: [
        RacesService
    ]
})
export class LeagueRaceTableV2 implements OnInit{
    constructor(private racesService: RacesService, private changeDetectorRef: ChangeDetectorRef) {}

    @Input() season: number = 0;

    raceDays: RaceDaysItem[] = [];
    raceDaysselectedTab: number | null = null;
    raceDaysloading: boolean = true;

    ngOnInit() {
        this.loadData();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['season'] || changes['group']) {
            this.loadData();
        }
    }

    loadData() {
        // Season 1 - Gruppe A
        this.racesService.getDaysForSeasonV2(String(this.season)).subscribe((races) => {
            this.raceDays = races;
            this.raceDaysloading = false;
            this.changeDetectorRef.detectChanges(); // Trigger change detection
            if (this.raceDays.length > 0) {
                this.raceDaysselectedTab = this.raceDays[0].raceday_id ?? null;
            }
            console.log("LeageRaceTable");
            console.log(this.raceDays);
        });
    }

    isKeyDriver(status: string): boolean {
        return status === "S";
    }
}
